import React, { useState } from 'react';
import { SpendingSumModel } from 'src/types/spending-sum.model';
import {
    SpendingSumParentRow,
    SpendingSumChildRow
} from 'src/components/atomic/molecules/spendingSumRows/SpendingSumRows';
import { CategoryModel } from 'src/types/category.model';
import Selectors from 'src/utils/selectors';

export const SpendingSumCollapsible = ({
    spendingSumParent,
    spendingSumChildren,
    categories,
    noChildrenInGrid,
    topBorder
}: {
    spendingSumParent: SpendingSumModel;
    spendingSumChildren: SpendingSumModel[];
    categories: CategoryModel[];
    noChildrenInGrid?: boolean;
    topBorder?: boolean;
}): JSX.Element => {
    const [open, setOpen] = useState<boolean>(false);

    const spendingSumChildrenTotal = spendingSumChildren.reduce((sum, e) => sum + e.spent, 0);
    const spendingSumParentName = categories?.find((category) => category.id === spendingSumParent.groupId).name;

    return (
        <div data-cy={Selectors.SpendSmart.SPENDING_SUM_COLLAPSIBLE}>
            <SpendingSumParentRow
                spendingSum={spendingSumParent}
                categories={categories}
                open={open}
                toggleOpen={() => setOpen(!open)}
                disabled={spendingSumChildrenTotal === 0}
                noChildrenInGrid={noChildrenInGrid}
                topBorder={topBorder}
            />
            {open && (
                <ul
                    id={`spending-sum-children-${spendingSumParent.groupId}`}
                    aria-labelledby={`spending-sum-parent-button-${spendingSumParent.groupId}`}
                >
                    {spendingSumChildren.map((e, i) => (
                        <SpendingSumChildRow
                            key={`SpendingSumChildRow-${i}`}
                            spendingSum={e}
                            spendingSumParentName={spendingSumParentName}
                            categories={categories}
                            darkTopBorder={i === 0}
                        />
                    ))}
                </ul>
            )}
        </div>
    );
};
